/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-04-29 10:39:42
 * @LastEditors: 刘行 liuhang@nextmar.com
 * @LastEditTime: 2025-05-14 14:35:34
 * @FilePath: /zeelool-nextjs/src/app/account/points-mall/components/CouponRedeemCard.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { IPointsMallCouponItemWithPoint } from '@/api/types/account';
import Coupon from '@/components/Coupon';
import RedeemButton from '@/components/Product/RedeemButton';
import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { useStore } from '@/providers/app-store-provider';
import { EPlatform } from '@/utils/enums/platform-enum';
import { Box } from '@mui/material';
import { useTranslations } from '@/i18n/use-translations';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useContext, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

type CouponInfo = IPointsMallCouponItemWithPoint;

interface CouponRedeemCardProps {
  couponInfo?: CouponInfo;
  onRedeemClick?: (index: number, product: CouponInfo) => void;
  index?: number;
  onInView?: (index: number, product: CouponInfo) => void;
  sendTrackCoupon?: (index: number, product: CouponInfo, sdEventName: string) => void;
}

export default function CouponRedeemCard({
  couponInfo,
  onRedeemClick,
  index,
  onInView,
  sendTrackCoupon,
}: CouponRedeemCardProps) {
  const { deviceType } = useContext(ResponsiveContext);
  const token = useStore((state) => state.token);
  const router = useRouter();
  const t = useTranslations('account.pointsMall.couponRedeemCard');
  const setShowLoginRegisterDialog = useStore((state) => state.setShowLoginRegisterDialog);
  const [couponCardRef, inView] = useInView({
    threshold: 0.8,
    triggerOnce: true,
  });
  useEffect(() => {
    if (inView) {
      onInView?.(index, couponInfo);
    }
  }, [inView]);

  useEffect(() => {
    const couponId = sessionStorage.getItem('zl-un-login-points-mall-coupon-id-click');
    if (token && couponId === couponInfo.id.toString()) {
      sessionStorage.removeItem('zl-un-login-points-mall-coupon-id-click');
      if (deviceType === EPlatform.WEB) {
        onRedeemClick?.(index, couponInfo);
      } else {
        router.push(`/account/points-mall-detail/${couponInfo.id}`);
      }
    }
  }, [token]);

  const onLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // 发送埋点数据
    const sendTrackEvent = () => {
      sendTrackCoupon?.(index, couponInfo, 'PointsMallCouponMkt_Click');
    };
    // 未登录处理
    if (!token) {
      e.preventDefault();
      setShowLoginRegisterDialog(true);
      sendTrackEvent();
      sessionStorage.setItem('zl-un-login-points-mall-coupon-id-click', couponInfo.id.toString());
      return;
    }
    // 发送埋点
    sendTrackEvent();

    // Web端阻止默认行为，使用弹窗兑换
    if (deviceType === EPlatform.WEB) {
      e.preventDefault();
      onRedeemClick?.(index, couponInfo);
    }
    // WAP端使用默认跳转行为
    if (deviceType === EPlatform.WAP) {
      sendTrackEvent();
    }
  };

  return (
    <Link
      prefetch={false}
      className="w-full cursor-pointer"
      href={`/account/points-mall-detail/${couponInfo.id}`}
      ref={couponCardRef}
      onClick={(e) => {
        onLinkClick(e);
      }}
    >
      <div
        className={`${deviceType === EPlatform.WEB ? 'aspect-square  rounded-12' : 'aspect-186/223'} bg-auxiliary-light-gray flex items-center justify-center`}
      >
        <div className="w-[80%]">
          <Coupon type="thumbnail" id={couponInfo.id} detail={couponInfo} />
        </div>
      </div>
      <div
        className={`flex items-center justify-between ${deviceType === EPlatform.WEB ? 'mt-16 mx-12' : 'mt-8 flex-col gap-6'} `}
      >
        <span className={`${deviceType === EPlatform.WEB ? 'text-16' : 'text-12'}`}>
          {Number(couponInfo.model_type) === 4 ? t('shippingCoupon') : t('coupon')}
        </span>
        <div
          className={`${deviceType === EPlatform.WEB ? 'text-16' : 'text-14'} text-warning font-bb flex-1 text-right whitespace-nowrap`}
        >
          {couponInfo.point > 1
            ? t('points_plural', { points: couponInfo.point })
            : t('points', { points: couponInfo.point })}
        </div>
      </div>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mt: deviceType === EPlatform.WEB ? 3 : 2,
          px: deviceType === EPlatform.WEB ? 1.5 : 1.75,
          height: deviceType === EPlatform.WEB ? '40px' : '28px',
        }}
      >
        <RedeemButton deviceType={deviceType}>{t('redeem')}</RedeemButton>
      </Box>
    </Link>
  );
}
